import { Check, ExternalLink, Download, MonitorPlay } from 'lucide-react';

interface BuildCardProps { previewUrl?: string; downloadUrl?: string; fileName?: string; fileSize?: number; }

export function BuildCard({ previewUrl, downloadUrl, fileName, fileSize }: BuildCardProps) {
  return (
    <div className="max-w-[85%] space-y-2 rounded-2xl border border-neon-green/20 bg-[hsl(var(--neon-green)/0.05)] px-5 py-4">
        <div className="flex items-center gap-2">
          <MonitorPlay size={14} className="text-neon-green" />
          <span className="text-sm font-semibold text-neon-green">试玩已生成</span>
        </div>
        <div className="flex flex-wrap items-center gap-3 text-xs">
          {previewUrl && (
            <a href={previewUrl} target="_blank" className="flex items-center gap-1 rounded-lg bg-muted/30 px-3 py-1.5 text-neon-cyan hover:bg-muted/50" rel="noreferrer">
              <ExternalLink size={12} />预览
            </a>
          )}
          {downloadUrl && (
            <a href={downloadUrl} target="_blank" className="flex items-center gap-1 rounded-lg bg-muted/30 px-3 py-1.5 text-muted-foreground hover:bg-muted/50" rel="noreferrer">
              <Download size={12} />下载
            </a>
          )}
          {fileName && <span className="text-muted-foreground">{fileName}</span>}
          {fileSize != null && <span className="text-muted-foreground">{(fileSize / 1024).toFixed(0)}KB</span>}
        </div>
    </div>
  );
}
